import 'xx';
import 'mansion-ui';
import 'font-awesome';

import React from 'react';
import ReactDOM from 'react-dom';

import Root from 'Core/Root';

ReactDOM.render(<Root />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./client/index.jsx